<p-table stripedRows id="dataTable"
    #dataTable
    [value]="items"
    sortField="Employeename"
    dataKey="id"
    editMode="row"
    tableStyleClass="table p-datatable-full"
    [scrollable]="true"
    [style]="{ width: '100%', 'min-width': '85em' }"
    scrollHeight="flex"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="6" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
        <tr>
            <td colspan="6" style="text-align: center">
                <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="header" let-item>
        <tr>
            <!-- Status -->
            <th class="p-header-cell status-cell"></th>
            <!-- View/Send -->
            <th class="p-header-cell small-cell" style="min-width: 200px"></th>
            <!-- PayPeriodEndDate -->
            <th class="p-header-cell small-cell">
                <div class="tabulator-col-content">
                    <div class="tabulator-col-title">Pay Period End Date</div>
                    <p-sortIcon
                        pSortableColumn="PayPeriodEndDate"
                        field="PayPeriodEndDate"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </div>
            </th>
            <!-- Sent Date -->
            <th class="p-header-cell small-cell">
                <div class="tabulator-col-content">
                    <div class="tabulator-col-title">Sent Date</div>
                    <p-sortIcon
                        pSortableColumn="SentDate"
                        field="SentDate"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </div>
            </th>
            <!-- Sent By -->
            <th class="p-header-cell small-cell">
                <div class="tabulator-col-content">
                    <div class="tabulator-col-title">Sent By</div>
                    <p-sortIcon
                        pSortableColumn="SentBy"
                        field="Sentby"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </div>
            </th>
            <!-- Payroll Expense Import Date -->
            <th class="p-header-cell small-cell">
                <div class="tabulator-col-content">
                    <div class="tabulator-col-title">Payroll Expense Import Date</div>
                    <p-sortIcon
                        pSortableColumn="SentBy"
                        field="ImportDate"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </div>
            </th>
            <!-- RecordsInFile -->
            <th class="p-header-cell tiny-cell" *ngIf="false">
                <div class="tabulator-col-content">
                    <div class="tabulator-col-title">Records In File</div>
                    <p-sortIcon
                        pSortableColumn="RecordsInFile"
                        field="RecordsInFile"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </div>
            </th>
            <!-- Export Status-->
            <th class="p-header-cell large-cell">
                <div class="tabulator-col-content">
                    <div class="tabulator-col-title">Status</div>
                    <p-sortIcon
                        pSortableColumn="Status"
                        field="Status"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </div>
            </th>
        </tr>
    </ng-template>
    <ng-template
        pTemplate="body"
        let-item
        let-edit="editing"
        let-ri="rowIndex"
        let-rowData
    >
        <tr class="p-datatable-row" data-id="row-{{ item?.id }}">
            <!-- Status -->
            <td class="p-datatable-cell status-cell" pFrozenColumn>
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.id + '-' + item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- View -->
            <td class="p-datatable-cell small-cell p-grid" style="justify-content: space-between; min-width: 200px">
                <button
                    *ngIf="item?.canView || !item?.canSend"
                    pButton
                    type="button"
                    icon="pi pi-eye"
                    class="p-button-secondary"
                    (click)="View.next(item)"
                    title="View"
                    label="View"
                ></button>
                <!-- send button-->
                <button
                    *ngIf="!item?.canView && item?.canSend"
                    pButton
                    type="button"
                    icon="pi pi-send"
                    class="p-button-primary"
                    (click)="Send.next(item?.ppid)"
                    title="Send"
                    label="Send"
                ></button>
                <button
                    *ngIf="item?.canSync"
                    pButton
                    type="button"
                    icon="pi pi-download"
                    class="p-button-secondary"
                    (click)="Sync.next(item?.ppid)"
                    title="Import payroll expenses for journal entry"
                    label="Expenses"></button>
                <button
                    *ngIf="item?.canRefresh"
                    pButton
                    type="button"
                    icon="pi pi-download"
                    class="p-button-secondary"
                    (click)="Refresh.next(item)"
                    title="Refresh import status"
                    label="Refresh"></button>
            </td>
            <!-- PayPeriodEndDate -->
            <td class="p-datatable-cell small-cell">
                {{ moment(item?.PayPeriodEndDate).format('MM/DD/YYYY') }}
            </td>
            <!-- SentDate -->
            <td class="p-datatable-cell small-cell">
                {{
                    item?.SentDate
                        ? moment(item?.SentDate).format('MM/DD/YYYY HH:mm:ss')
                        : ''
                }}
            </td>
            <!-- SentBy -->
            <td class="p-datatable-cell small-cell">
                {{ item?.SentBy }}
            </td>
            <!-- RecordsInFile -->
            <td class="p-datatable-cell tiny-cell" *ngIf="false">
                {{ item?.RecordsInFile }}
            </td>
            <!-- Payroll Expense Import Date -->
            <td class="p-datatable-cell small-cell">
                {{
                    item?.ImportDate
                        ? moment(item?.ImportDate).format('MM/DD/YYYY HH:mm:ss')
                        : ''
                }}
            </td>
            <!-- Export Status -->
            <td class="p-datatable-cell large-cell">
                {{ item?.ExportStatus }}
            </td>
        </tr>
    </ng-template>
</p-table>
